import { render } from "./ResearchView.vue?vue&type=template&id=541ad666"
import script from "./ResearchView.vue?vue&type=script&lang=js"
export * from "./ResearchView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cookiemonster/Isaac_Files/Projects_Software/personal-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__